import React, { useState, useEffect } from 'react';
import Telegram from './images/telegram-icon.png';
import Twitter from './images/twitter-icon.png';
import Reddit from './images/reddit-icon.png';
import Discord from './images/discord-icon.png';
import Facebook from './images/facebook-icon.png';
import Instagram from './images/instagram-icon.png';
import './sitelink-styles.css';

// Function to fetch sites data from Strapi API
const fetchSitesData = async () => {
  const response = await fetch(
    'https://api.avalanche.cash/api/footer-links?populate=*'
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch sites data: ${response.status} ${response.statusText}`
    );
  }
  const data = await response.json();
  return data.data;
};

// Function to fetch social links data from Strapi API
const fetchSocialLinksData = async () => {
  const response = await fetch(
    'https://api.avalanche.cash/api/socials?populate=*'
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch social links data: ${response.status} ${response.statusText}`
    );
  }
  const data = await response.json();
  return data.data;
};

const socials = [
  {
    img: Telegram,
    href: 'https://t.me/ecash',
  },
  {
    img: Discord,
    href: 'https://discord.gg/BxUpjWpjtY',
  },
  {
    img: Reddit,
    href: 'https://www.reddit.com/r/ecash/',
  },
  {
    img: Twitter,
    href: 'https://x.com/ecash',
  },
  {
    img: Facebook,
    href: 'https://www.facebook.com/groups/ecashofficial',
  },
  {
    img: Instagram,
    href: 'https://www.instagram.com/ecashnetwork/',
  },
];

const Tile = ({ href, img, alt, h4, p }) => {
  return (
    <a className="sitelink-tile" href={href} target="_blank" rel="noreferrer">
      {img && <img src={img} alt={alt} />}
      <div className="tile-text">{p}</div>
    </a>
  );
};

const SocialIcon = ({ href, img }) => {
  return (
    <a className="social-link" href={href} target="_blank" rel="noreferrer">
      <img src={img} alt={'ecash social'} />
    </a>
  );
};

const SiteLinks = () => {
  const [sites, setSites] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);

        // Fetch both sites and social links data in parallel
        const [sitesData, socialLinksData] = await Promise.all([
          fetchSitesData(),
          fetchSocialLinksData(),
        ]);

        // Transform sites API data to match component structure
        const transformedSites = sitesData.map((item) => {
          const attributes = item.attributes;
          const imageData = attributes.image?.data;

          return {
            h4: attributes.title,
            p: attributes.description,
            img: imageData?.attributes?.url
              ? `https://api.avalanche.cash${imageData.attributes.url}`
              : null,
            href: attributes.url,
            order: attributes.order,
          };
        });

        // Transform social links API data to match component structure
        const transformedSocialLinks = socialLinksData.map((item) => {
          const attributes = item.attributes;
          const imageData = attributes.image?.data;

          return {
            href: attributes.url,
            img: `https://api.avalanche.cash${imageData?.attributes?.url}`,
            alt: 'social link',
          };
        });

        // Sort by order field
        transformedSites.sort((a, b) => (a.order || 0) - (b.order || 0));

        setSites(transformedSites);
        setSocialLinks(transformedSocialLinks);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error loading data:', err);
        // Fallback to hardcoded social links if API fails
        setSocialLinks(socials);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <div className="sitelink-ctn" style={{ animationDelay: '1s' }}>
        <h3>Other Cool Sites</h3>
        <div className="sitelink-inner-ctn">
          <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>
        </div>
        <div className="social-link-ctn">
          {(socialLinks.length > 0 ? socialLinks : socials).map((social) => {
            return (
              <SocialIcon
                key={social.href}
                href={social.href}
                img={social.img}
              />
            );
          })}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="sitelink-ctn" style={{ animationDelay: '1s' }}>
        <h3>Other Cool Sites</h3>
        <div className="sitelink-inner-ctn">
          <div style={{ textAlign: 'center', padding: '20px' }}>
            Error loading sites
          </div>
        </div>
        <div className="social-link-ctn">
          {(socialLinks.length > 0 ? socialLinks : socials).map((social) => {
            return (
              <SocialIcon
                key={social.href}
                href={social.href}
                img={social.img}
              />
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="sitelink-ctn">
      <h3>Other Cool Sites</h3>
      <div className="sitelink-inner-ctn">
        {sites.map((site) => {
          if (window.location.hostname === site.href.substring(8)) {
            return null;
          } else
            return (
              <Tile
                key={site.href}
                href={site.href}
                img={site.img}
                alt={site.h4}
                h4={site.h4}
                p={site.p}
              />
            );
        })}
      </div>
      <div className="social-link-ctn">
        {(socialLinks.length > 0 ? socialLinks : socials).map((social) => {
          return (
            <SocialIcon key={social.href} href={social.href} img={social.img} />
          );
        })}
      </div>
    </div>
  );
};

export default SiteLinks;
